import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { STRATEGIES_QUERY_KEY } from "./useStrategies";

type UpdateStrategyBody = components["schemas"]["UpdateStrategyBody"];
type StrategyResponse = components["schemas"]["StrategyResponse"];

export type UpdateStrategyVariables = {
  strategyId: string;
  body: UpdateStrategyBody;
};

export function useUpdateStrategy() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<StrategyResponse, Error, UpdateStrategyVariables>({
    mutationFn: async ({ strategyId, body }) => {
      const { data, error } = await client.PATCH("/api/strategies/{strategy_id}", {
        params: { path: { strategy_id: strategyId } },
        body,
      });
      if (error !== undefined) {
        throw new Error(`Failed to update strategy ${strategyId}`);
      }
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: STRATEGIES_QUERY_KEY });
    },
  });
}
